import debug from 'debug';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import MultiViewsOverlay from 'Minetilbud/Shared/Components/overlay/multi-views-overlay';
import OverlayBehaviour from 'Minetilbud/Shared/Components/overlay/behaviour';
import FavoriteInfo from './render/favorite-info';
import LoginForm from './render/login-form';
import Behaviour from './static/behaviour';

const log = debug('FrontPageFavoritesOverlay');

class FrontPageFavoritesOverlay {
	constructor(customerId) {
		this.customerId = customerId;

		this.infoToFormEvent = this.infoToFormHandler.bind(this);
		this.modalCloseEvent = this.modalCloseHandler.bind(this);
		this.overlayHideEvent = this.overlayHideHandler.bind(this);

		this.initalize();
	}

	eventListeners() {
		document.addEventListener(OverlayBehaviour.eventKeys.hide, this.overlayHideEvent, false);
		document.addEventListener(OverlayBehaviour.eventKeys.modalClose, this.modalCloseEvent, false);
		document.addEventListener(Behaviour.eventKeys.infoToForm, this.infoToFormEvent, false);
	}

	/**
	 * @param {CustomEvent} event
	 */
	infoToFormHandler({ detail: { options: { instanceId } } }) {
		if (instanceId !== this.instanceId) return;
		
		// Flip to Login Form
		this.overlay.flip(0, 1);
	}

	initalize() {
		this.setup();
		this.eventListeners();
	}

	/**
	 * @param {CustomEvent} event
	 */
	modalCloseHandler({ detail: { options: { instanceId } } }) {
		if (instanceId !== this.instanceId) return;
		this.overlay.hide();
	}

	/**
	 * @param {CustomEvent} event
	 */
	overlayHideHandler({ detail: { options: { instanceId } } }) {
		if (instanceId !== this.instanceId) return;

		enableBodyScroll(this.overlay.get());
		this.overlay.remove();
	}

	async setup() {
		this.overlay = new MultiViewsOverlay();
		this.instanceId = this.overlay.getInstanceId();

		// viewIndex: 0
		const favoriteInfo = new FavoriteInfo(this.instanceId);
		const favoriteInfoDom = await favoriteInfo.get();
		this.overlay.create(favoriteInfoDom);
		favoriteInfo.initialize();

		// viewIndex: 1
		const loginForm = new LoginForm(this.instanceId, this.customerId);
		const loginFormDom = await loginForm.get();
		this.overlay.create(loginFormDom);
		loginForm.initialize();

		this.overlay.show(0);
		disableBodyScroll(this.overlay.get());
	}
}

export default FrontPageFavoritesOverlay;
